import React, { useState, useEffect, useCallback } from "react";
import { CALL_API } from "../../Common/api";
import {
  useParams,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { Row, Col, Card, Table, Typography, message, Modal } from "antd";
import { ReactComponent as Calendar } from "../../assets/images/calendar.svg";
import { ReactComponent as Clock } from "../../assets/images/clock.svg";
import { ReactComponent as EventActive } from "../../assets/images/event-over.svg";
import { ReactComponent as Line } from "../../assets/images/Line 1.svg";
import { ReactComponent as Loc } from "../../assets/images/BLUELOC.svg";
import { ReactComponent as Notice } from "../../assets/images/gridicons_notice-outline.svg";
import { ReactComponent as Cut } from "../../assets/images/ix_cut.svg";
import { ReactComponent as AlertLock } from "../../assets/images/lucide_lock.svg";
import { ReactComponent as Caution } from "../../assets/images/caution.svg";
import { ReactComponent as BlueLoc } from "../../assets/images/BLUELOC.svg";
import { ReactComponent as Trackright } from "../../assets/images/trackright.svg";
import { TripStatus } from "../../Common/constant";
import styled from "styled-components";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import MapComponent from "../../Reusablecomponents/MapComponent";
import { NavbarCollapse } from "react-bootstrap";
import { useSelector } from "react-redux";
const { Text } = Typography;
export const TitleStyle = styled.div`

  @media (min-width: 320px) and (max-width: 480px) {
    .container_for_header_subtwo {
      display: flex;
      flex-wrap: wrap;
    }
    .container_for_headersub_three {
      display: flex;
      flex-wrap: wrap;
      justify-content: end;
    }
  }
  div[tabindex="0"] {
    height: 100vh !important;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    .section_card_one {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    div[tabindex="0"] {
      height: 50vh !important;
    }
  }

  .section_card_one {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  /* Responsive Modal Map Container */
  .modal_map_container {
    width: 100%;
    height: 350px; /* Responsive fixed height for map on desktop */
    overflow: hidden;
    position: relative;
    border-radius: 10px;
  }
  .modal_map_container .container_formapp {
    height: 100% !important;
    width: 100% !important;
  }
  .modal_map_container div[tabindex="0"] {
    height: 100% !important;
    width: 100% !important;
  }
  @media (max-width: 480px) {
    .modal_map_container {
      height: 250px; /* Responsive fixed height for map on mobile */
    }
  }

  container_six {
    color: green;
  }
  .conatiner_seven {
    padding-top: 17px;
  }
  .container_five {
    border-radius: 50%;
    width: 12px;
    height: 12px;
    display: block;
    background-color: green;
  }
  .container_five {
    color: green;
  }

  .container_three {
    margin-top: 2%;
  }
  .container_four {
    color: #151515;
    font-size: 1rem;
    font: inter;
    font-weight: 500;
  }
  .container_two > div {
    padding: 15px 5px 5px 15px;
  }
  .container_four {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .container_one {
    display: flex;
    justify-content: space-between;
    padding: 8px 8px 18px 8px;
    align-items: center;
    border-bottom: 1px solid #e7e7ed;
  }
  .container_one label {
    font-family: Inter;
    font-weight: 500;
    font-size: 3rem !important;
  }
  p {
    margin-bottom: 0px;
    font-size: 1rem;
    font-family: Inter;
    font-weight: 400;
    font-style: Regular;
    color: #3d3d3d;
  }
  .container_Green {
    color: #2c963d;
    display: flex;
    gap: 5px;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
  }
  .container_Orange {
    color: #e4a400;
    display: flex;
    gap: 5px;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
  }
  .container_Red {
    color: #f20000;
    display: flex;
    gap: 5px;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
  }

  .trackright_logo {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
    flex-direction: column;
    align-items: center;
  }
  .trackright_ai_cargo {
    font-size: 1rem;
    padding: 4px 4px 4px 4px;
  }
  .section_card_one {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .section-card {
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    background-color: #ffffff;
  }
  .items-key {
    position: relative;
    margin-bottom: 20px;
  }
  .Event-card {
    position: relative;
    padding-left: 24px;
  }
  .Event-card-line {
    position: absolute;
    left: 12px;
    top: 30px;
  }
  .Event-card-circle {
    position: absolute;
    left: 2px;
    top: -1px;
  }
  .Event-card-text {
    margin-left: 24px;
  }
  .Event-card-text-bold {
    font-weight: bold;
  }
  .Event-card-text-gray {
    color: #979797;
    font-size: 14px;
  }
  .Event-card-text-flex {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .Event-card-text-flex-calendar {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .Event-card-text-flex-clock {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .Event-card-text-flex-calendar span,
  .Event-card-text-flex-clock span {
    margin-left: 4px;
    color: #979797;
    font-size: 14px;
  }
`;

const TripTrack = () => {
  const { tripId } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const aVehid = searchParams.get("vehId");
  const ShipmentTypeId = searchParams.get("shipmentTypeId");
  const MCID = searchParams.get("MCID");
  const UID = searchParams.get("UID");
  const [loading, setLoading] = useState(false);
  const [tripListData, setTripListData] = useState([]);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [eventList, setEventList] = useState([]);
  const [driverEvents, setDriverEvents] = useState([]);
  const [carbon, setCarbon] = useState([]);
  const [timeandDist, setTimeandDist] = useState([]);
  const [summaryData, setSummaryData] = useState([]);
  const [routeData, setRouteData] = useState([]);
  const [mapData, setMapData] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [renderMap, setRenderMap] = useState(false);

  useEffect(() => {
    if (isModalVisible) {
      const timer = setTimeout(() => {
        setRenderMap(true);
      }, 300);
      return () => clearTimeout(timer);
    } else {
      setRenderMap(false);
    }
  }, [isModalVisible]);

  const navigate = useNavigate();
  const [vehicleList, setVehicleList] = useState([]);

  const fetchAllVehicle = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllVehicle");
      setVehicleList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchAllVehicle();
  }, []);

  // function formatSecondsToHMS(seconds) {
  //   if (!seconds || isNaN(seconds)) return "-";
  //   const h = Math.floor(seconds / 3600);
  //   const m = Math.floor((seconds % 3600) / 60);
  //   let result = "";
  //   if (h > 0) result += `${h} Hour${h > 1 ? "s" : ""} `;
  //   if (m > 0) result += `${m} Minute${m > 1 ? "s" : ""}`;
  //   return result.trim() || "0 Minutes";
  // }
  const formatSecondsToHMS = (timeInSeconds) => {
    const totalSeconds = Number(timeInSeconds) || 0;

    const days = Math.floor(totalSeconds / (24 * 60 * 60));
    const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
    const mins = Math.floor((totalSeconds % (60 * 60)) / 60);

    const parts = [];

    if (days > 0) {
      parts.push(`${days} ${days === 1 ? "day" : "days"}`);
      parts.push(
        `${String(hours).padStart(2, "0")} ${hours === 1 ? "hour" : "hours"}`,
      );
      parts.push(
        `${String(mins).padStart(2, "0")} ${mins === 1 ? "minute" : "minutes"}`,
      );
    } else if (hours > 0) {
      parts.push(
        `${String(hours).padStart(2, "0")} ${hours === 1 ? "hour" : "hours"}`,
      );
      parts.push(
        `${String(mins).padStart(2, "0")} ${mins === 1 ? "minute" : "minutes"}`,
      );
    } else {
      // Only minutes if no hours or days
      parts.push(
        `${String(mins).padStart(2, "0")} ${mins === 1 ? "minute" : "minutes"}`,
      );
    }

    return parts.join(" ");
  };

  const summaryData1 = [
    { label: "Trip ID", value: tripListData?.[0]?.TripCode },
    { label: "Vehicle", value: tripListData?.[0]?.VEHREGNO },
    { label: "Device Number", value: tripListData?.[0]?.DeviceName },
    { label: "Container Number", value: tripListData?.[0]?.ContainerNo },
    { label: "Driver Name", value: tripListData?.[0]?.Drivername },
    {
      label: "Free Days ",
      value: tripListData?.[0]?.DaysLeft,
    },
    { label: "EventStatus", value: tripListData?.[0]?.EventStatus },
  ];

  const summaryData2 = [
    {
      label: "Total Trip Time:",
      value: formatSecondsToHMS(timeandDist?.[0]?.TransportationTime) || "0 s",
    },
    {
      label: "Carbon Footprint:",
      value: `${tripListData?.[0]?.CarbonFootPrint ?? 0} KgCO2`,
    },
    {
      label: "Distance covered:",
      value: `${timeandDist?.[0]?.TransportationMileage} Kms` || "0 Km",
    },
  ];

  //ACTUAL COLUMNS
  const consignColumns1 = [
    {
      title: "Container Code",
      dataIndex: "CODE",
      key: "CODE",
    },
    {
      title: "Consignor",
      dataIndex: "ConsignorName",
      key: "ConsignorName",
    },
    {
      title: "Consignee",
      dataIndex: "ConsigneeName",
      key: "ConsigneeName",
    },
    {
      title: "Transporter",
      dataIndex: "Transporter",
      key: "Transporter",
    },
    {
      title: "Event Status",
      dataIndex: "EventStatus",
      key: "EventStatus",
    },
    {
      title: "Last Location",
      dataIndex: "LastlocationName",
      key: "LastlocationName",
      render: (text) => (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            color: "#4C94FF",
          }}
        >
          <Loc />
          {text}
        </span>
      ),
    },
  ];

  // const alertData = [
  //   {
  //     icon: <Caution style={{ color: "red", fontSize: 18 }} />,
  //     title: "Route Deviation Alarm",
  //   },
  //   {
  //     icon: <AlertLock style={{ color: "red", fontSize: 18 }} />,
  //     title: "Unlocked Container Exit Alarm",
  //   },
  //   {
  //     icon: <Cut style={{ color: "red", fontSize: 18 }} />,
  //     title: "Rope Cut Alarm",
  //   },
  //   {
  //     icon: <Notice style={{ color: "red", fontSize: 18 }} />,
  //     title: "Tamper Alert",
  //   },
  //   {
  //     icon: <AlertLock style={{ color: "red", fontSize: 18 }} />,
  //     title: "Restricted Area Unlock Attempt",
  //   },
  // ];

  const fetchTripInfoList = useCallback(async () => {
    try {
      setLoading(true);

      const response = await CALL_API(
        "GET",
        `container/getContainerConsignDetails?aTripId=${tripId}&aVehid=${aVehid}`,
      );

      const list = response?.data; // <--- FIXED HERE

      if (!Array.isArray(list)) {
        throw new Error("Trip info list is not an array");
      }

      const enrichedData = await Promise.all(
        list.map(async (record) => {
          if (record.Lastlocation) {
            const [latStr, lonStr] = record.Lastlocation.split(",");
            const lat = parseFloat(latStr);
            const lon = parseFloat(lonStr);
            const locationName = await fetchLocation(lat, lon);
            return { ...record, LastlocationName: locationName };
          }
          return { ...record, LastlocationName: "-" };
        }),
      );

      setTripListData(enrichedData);
    } catch (error) {
      console.error("[fetchTripInfoList] error:", error);
      message.error("Error fetching trip info");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchLocation = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lon},${lat}.json?access_token=pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow`,
      );
      const data = await response.json();
      return data?.features?.[0]?.place_name || "Unknown Location";
    } catch (error) {
      console.error("Error fetching location:", error);
      return "Unknown Location";
    }
  };

  const fetchEventTable = useCallback(async () => {
    try {
      setLoading(true);
      const response = await CALL_API(
        "GET",
        `container/getContainerEventdetails?aTripId=${tripId}`,
      );

      const list = response?.data || [];
      setDriverEvents(list);

      if (!Array.isArray(list)) {
        throw new Error("Event data is not an array");
      }

      const formatted = list
        .sort((a, b) => new Date(a.MODON) - new Date(b.MODON))
        .map((event) => {
          const utcDate = new Date(event.MODON);
          const adjustedDate = new Date(utcDate.getTime()); // subtract 3 hours in ms

          const date = adjustedDate
            .toISOString()
            .split("T")[0]
            .split("-")
            .reverse()
            .join("/"); // DD/MM/YYYY

          let hours = adjustedDate.getUTCHours();
          const minutes = adjustedDate
            .getUTCMinutes()
            .toString()
            .padStart(2, "0");
          const ampm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12 || 12; // Convert to 12-hour format

          const time = `${hours}:${minutes} ${ampm}`;

          return {
            key: event.EVID || 0,
            event: event.EventName?.replace(/_/g, " ") || "-",
            date,
            time,
            Lat: event.LAT,
            Lng: event.LNG,
          };
        });

      setEventList(formatted);
      await calculateContainerCarbonFootPrints();
    } catch (error) {
      console.error("[fetchEventTable] error:", error);
      message.error("No event data available");
    } finally {
      setLoading(false);
    }
  }, []);

  const calculateContainerCarbonFootPrints = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `container/calculateContainerCarbonFootPrint?MCID=${Number(MCID)}`,
      );
      setCarbon(data);
    } catch (error) {
      console.error("[calculateContainerCarbonFootPrints] error:", error);
      message.error("Error fetching Carbon Footprint");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchTimeandDistance = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `container/getTransportationReport?aTripId=${tripId}`,
      );
      setTimeandDist(data);
    } catch (error) {
      console.error("[fetchTripInfoList] error:", error);
      message.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchTripSummary = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `container/queryVehicleById?aTripId=${tripId}`,
      );
      const record = data?.FObject?.[0];
      if (record?.FLatitude && record?.FLongitude) {
        const locationName = await fetchLocation(
          record.FLatitude,
          record.FLongitude,
        );
        setMapData({
          ...record,
          locationName,
        });
      }
      setSummaryData(data);
    } catch (error) {
      console.error("[fetchTripInfoList] error:", error);
      message.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchPlannedRoutes = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `container/fetchRoutesByTripId?tripId=${tripId}`,
      );
      setRouteData(data);
    } catch (error) {
      console.error("[fetchRoutes] error:", error);
      message.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  }, []);

  const handleKPIAlertss = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", `container/handleKPIAlerts`, {
        ShipmentType: Number(ShipmentTypeId),
        UserId: Number(UID),
        MCID: Number(MCID),
      });
    } catch (error) {
      console.error("[handleKPIAlertss] error:", error);
      message.error("Error fetching Carbon Footprint");
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    if (tripId) {
      fetchEventTable();
    }
  }, [tripId]);
  useEffect(() => {
    fetchTimeandDistance();
  }, []);
  useEffect(() => {
    fetchPlannedRoutes();
  }, []);
  useEffect(() => {
    fetchTripSummary();
  }, []);
  useEffect(() => {
    handleKPIAlertss();
  }, []);
  useEffect(() => {
    fetchTripInfoList();
  }, [tripId, aVehid]);
  // Handlers for modal
  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const handleclickme = () => {
    window.open("https://trackright.africa/", "_blank");
  };
  const vehicleReg = aVehid;

  const vehicleData = vehicleList.find((v) => v.FGUID === vehicleReg);

  const events = driverEvents || [];

  if (!events.length) {
    return ""; // or whatever default you want
  }

  const sortedEvents = [...events].sort(
    (a, b) => new Date(a.MODON) - new Date(b.MODON),
  );

  const firstDate = new Date(sortedEvents[0].MODON);
  const lastDate = new Date(sortedEvents[sortedEvents.length - 1].MODON);

  let totalSeconds = Math.floor((lastDate - firstDate) / 1000);

  const days = Math.floor(totalSeconds / 86400);
  totalSeconds %= 86400;

  const hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const parts = [];

  if (days > 0) parts.push(`${days} day${days > 1 ? "s" : ""}`);
  if (hours > 0) parts.push(`${hours} hr`);
  if (minutes > 0) parts.push(`${minutes} min${minutes > 1 ? "s" : ""}`);
  if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);

  const formatted = parts.join(" ");
  return (
    <>
      <TitleStyle>
        <div onClick={handleclickme} className="trackright_logo">
          <Trackright />
          <p className="trackright_ai_cargo">
            {" "}
            (TrackRight AI Cargo Live Tracking)
          </p>
        </div>
        <Row gutter={16}>
          {/* Left Column: MapComponent */}
          <Col xs={24} md={24} lg={14}>
            <div className="section-card">
              <div className="section_card_one">
                <Card>
                  <MapComponent
                    containerDetailMap={mapData}
                    companyName={timeandDist}
                    containerplanedRoutes={routeData}
                    locationsTLAI={driverEvents}
                    tripListData={tripListData}
                    locationName={tripListData}
                    triptracktruckicon={true}
                    status={tripListData[0]?.Status}
                    mapType="cargo"
                  />
                </Card>
              </div>
            </div>
          </Col>

          {/* Right Column: Events */}
          <Col xs={24} md={24} lg={10}>
            <Row gutter={12}>
              <Col xs={24} md={24}>
                <Card>
                  <div className="container_on">
                    <div className="container_one">
                      <p className="container_four">
                        Trip ID: {tripListData?.[0]?.TripCode ?? ""}
                      </p>
                      <p className="container_four">
                        {" "}
                        Status<div className="container_five"></div>
                        <p className="container_six">
                          {TripStatus.find(
                            (s) => s.value === tripListData?.[0]?.Status,
                          )?.name || ""}
                        </p>
                      </p>
                    </div>
                    <Row>
                      <Col xl={8}>
                        <div className="container_two">
                          <div>
                            <p className="container_four">Driver Name</p>
                            <p className="conatiner_seven">
                              {tripListData?.[0]?.Drivername}{" "}
                            </p>
                          </div>
                          <div>
                            <p className="container_four"> Container Number</p>
                            <p className="conatiner_seven">
                              {tripListData?.[0]?.ContainerNo}{" "}
                            </p>
                          </div>
                          <div>
                            <p className="container_four">Total Trip Time:</p>
                            <p className="conatiner_seven">
                              {formatted || "0 s"}
                            </p>
                          </div>
                        </div>
                      </Col>
                      <Col xl={8}>
                        <div className="container_two">
                          <div>
                            <p className="container_four">Vehicle</p>
                            <p className="conatiner_seven">
                              {tripListData?.[0]?.VEHREGNO}{" "}
                            </p>
                          </div>
                          <div>
                            <p className="container_four">Free Days </p>
                            <p className="conatiner_seven">
                              {tripListData?.[0]?.DaysLeft
                                ? tripListData?.[0]?.DaysLeft
                                : "-"}
                            </p>
                          </div>
                          <div>
                            <p className="container_four">Distance covered:</p>
                            <p className="conatiner_seven">
                              {`${timeandDist?.[0]?.TransportationMileage} Kms` ||
                                "0 Km"}
                            </p>
                          </div>
                        </div>
                      </Col>
                      <Col xl={8}>
                        <div className="container_two">
                          <div>
                            <p className="container_four">Device Number</p>
                            <p className="conatiner_seven">
                              {tripListData?.[0]?.DeviceName}{" "}
                            </p>
                          </div>
                          <div>
                            <p className="container_four">Carbon Footprint:</p>
                            <p className="conatiner_seven">
                              {`${tripListData?.[0]?.CarbonFootPrint ?? 0
                                } KgCO2`}
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Card>
              </Col>
              <Col className="container_three" xs={24} md={24}>
                <Card
                  title={`Events • ${Number(ShipmentTypeId) === 1 ? "Import" : "Export"
                    }`}
                >
                  <div className="Event-card">
                    {eventList.map((item, index) => (
                      <div
                        key={item.key}
                        className="items-key"
                        onClick={() => {
                          setSelectedRecord(item);
                          setIsModalVisible(true);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {/* Vertical Line SVG */}
                        {index !== eventList.length - 1 && (
                          <div className="Event-card-line">
                            <Line />
                          </div>
                        )}

                        {/* Circle Icon SVG */}
                        <div className="Event-card-circle">
                          <EventActive />
                        </div>

                        {/* Event Details */}
                        <div className="Event-card-text">
                          <div className="Event-card-text-bold">
                            {item.event}
                          </div>
                          <div className="Event-card-text-gray">
                            <div className="Event-card-text-flex-calendar">
                              <Calendar />
                              <span>{item.date}</span>
                            </div>
                            <div className="Event-card-text-flex-clock">
                              <Clock />
                              <span>{item.time}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        <Modal
          title="Event Locations"
          visible={isModalVisible}
          onCancel={handleCloseModal}
          footer={null}
          destroyOnClose={true}
          width={500}
          style={{ maxWidth: "90%", margin: "0 auto" }}
        >
          {renderMap && selectedRecord && (
            <TitleStyle>
              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "10px",
                  marginBottom: "16px",
                }}
                className="modal_map_container"
              >
                <MapComponent
                  className="section_card_two"
                  locationsTL={[selectedRecord]}
                  isminimap={true}
                  triprackAI={true}
                  containerDetailMap={
                    selectedRecord?.Lat && selectedRecord?.Lng
                      ? {
                        FLatitude: selectedRecord.Lat,
                        FLongitude: selectedRecord.Lng,
                        locationName:
                          selectedRecord?.ConsigneeName || "Unknown Location",
                      }
                      : null
                  }
                  driverName={
                    tripListData?.[0]?.Drivername ?? tripListData?.[0]?.Drivername
                  }
                />
                {/* Map Placeholder */}
              </div>
            </TitleStyle>
          )}
        </Modal>

        {/* TRIP INFO */}
        <Row gutter={16} style={{ marginTop: "16px" }}>
          <Col xs={24}>
            <div>
              <Card title="TRIP INFO">
                <StyledTable
                  columns={consignColumns1}
                  dataSource={tripListData}
                  pagination={false}
                />
              </Card>
            </div>
          </Col>
        </Row>
        {/* New Row for Alerts */}
        <Row gutter={[0, 16]} style={{ marginTop: "16px" }}>
          <Col xs={24}>
            {/* <Card
            title={
              <Text
                style={{ color: "#F20000", fontWeight: 400, fontSize: "16px" }}
              >
                ALERTS
              </Text>
            }
            style={{ borderRadius: 8 }}
          >
            {" "}
            {alertData.map((alert, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  borderBottom: "1px solid #f0f0f0",
                  paddingBottom: 12,
                  marginBottom: 12,
                }}
              >
                <div
                  style={{
                    width: 220,
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                  }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    {alert.icon}
                    <Text
                      style={{
                        color: "#101010",
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      {alert.title}
                    </Text>
                  </div>

                  <div>
                    <Text
                      type="secondary"
                      style={{ fontSize: 14, color: "#808080" }}
                    >
                      Location
                    </Text>
                    <br />
                    <BlueLoc style={{ color: "#1890ff" }} />{" "}
                    <Text style={{ color: "#1890ff" }}>The Westwood</Text>
                  </div>
                </div>

                <div style={{ width: 100 }}>
                  <Text
                    type="secondary"
                    style={{ fontSize: 14, color: "#808080" }}
                  >
                    Date
                  </Text>
                  <br />
                  <Text>26-02-2025</Text>
                </div>

                <div style={{ width: 100 }}>
                  <Text
                    type="secondary"
                    style={{ fontSize: 14, color: "#808080" }}
                  >
                    Time
                  </Text>
                  <br />
                  <Text>17:08:32</Text>
                </div>
              </div>
            ))}
          </Card> */}
          </Col>
        </Row>
      </TitleStyle>
    </>
  );
};

export default TripTrack;
